export const FORGOTTEN_PASSWORD_TRIGGER = 'FORGOTTEN_PASSWORD_TRIGGER';
export const FORGOTTEN_PASSWORD_API_PREFIX = 'FORGOTTEN_PASSWORD_API';
export const FORGOTTEN_PASSWORD_API_REQUEST = 'FORGOTTEN_PASSWORD_API_REQUEST';
export const FORGOTTEN_PASSWORD_API_SUCCESS = 'FORGOTTEN_PASSWORD_API_SUCCESS';
export const FORGOTTEN_PASSWORD_API_FAILURE = 'FORGOTTEN_PASSWORD_API_FAILURE';
